// NOTE: minimal compatibility with 'Form' events
export default {
  DataChanged: 'CHANGE_DATA',
  DataLoaded: 'DONE_LOADING',
  DataSaved: 'DONE_SAVING',
  LoadFailed: 'FAILED_LOADING',
  SaveFailed: 'FAILED_SAVING',
  SavingData: 'SAVE',
};
